import { USERS_CONTENT, type UserErrorKey } from '../../content/sections/users.js';
import { ApiError } from '../../lib/http.js';

/* Classifica o erro num código estável — o texto mora só no catálogo bilíngue
   (`users-modals.ts`). Mapeado via `switch` para chaves em camelCase — não dá para indexar um
   `Record` com a chave snake_case do `ApiErrorCode` sem violar `useNamingConvention` no
   catálogo. */
function userErrorKey(err: unknown): UserErrorKey {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'not_found':
        return 'notFound';
      case 'not_blocked':
        return 'notBlocked';
      case 'email_taken':
        return 'emailTaken';
      case 'unauthorized':
        return 'unauthorized';
      case 'network':
        return 'network';
      default:
        return 'default';
    }
  }
  return 'unexpected';
}

/**
 * Mensagem traduzida para erros de operação em usuários (impersonate/license/session/device).
 *
 * O parâmetro `errors` é o mapa do locale corrente (`useUsersContent().errors`); o default
 * pt-BR existe para chamadores fora de componente (testes unitários).
 */
export function userErrorMessage(
  err: unknown,
  errors: Readonly<Record<UserErrorKey, string>> = USERS_CONTENT['pt-BR'].errors,
): string {
  return errors[userErrorKey(err)];
}
